// Converts <sup>/<sub> markup in API-supplied names to Unicode super/subscripts
// and strips other known inline HTML tags. Non-string input is returned unchanged.

import he from "he";

const SUP_MAP = {
  0: "⁰", 1: "¹", 2: "²", 3: "³", 4: "⁴", 5: "⁵", 6: "⁶", 7: "⁷", 8: "⁸", 9: "⁹",
  "+": "⁺", "-": "⁻", "−": "⁻", "=": "⁼", "(": "⁽", ")": "⁾", n: "ⁿ", i: "ⁱ",
};

const SUB_MAP = {
  0: "₀", 1: "₁", 2: "₂", 3: "₃", 4: "₄", 5: "₅", 6: "₆", 7: "₇", 8: "₈", 9: "₉",
  "+": "₊", "-": "₋", "−": "₋", "=": "₌", "(": "₍", ")": "₎",
};

const mapChars = (str, map) =>
  Array.from(str)
    .map((ch) => map[ch] ?? ch)
    .join("");

const SUP_RE = /<\s*sup(?:\s[^>]*)?>([\s\S]*?)<\s*\/\s*sup\s*>/gi;
const SUB_RE = /<\s*sub(?:\s[^>]*)?>([\s\S]*?)<\s*\/\s*sub\s*>/gi;
// Only known inline HTML tags are stripped, so text like "x<y and y>z" survives.
const INLINE_TAG_RE =
  /<\/?(?:b|i|u|em|strong|span|br|p|sup|sub|small|font)(?:\s[^>]*)?\/?>/gi;

export function formatSupSubTags(text) {
  if (typeof text !== "string") return text;
  return text
    .replace(SUP_RE, (_, inner) => mapChars(inner, SUP_MAP))
    .replace(SUB_RE, (_, inner) => mapChars(inner, SUB_MAP))
    .replace(INLINE_TAG_RE, "");
}

export function formatPwoName(text) {
  if (typeof text !== "string") return text;
  return formatSupSubTags(he.decode(text));
}

export default formatSupSubTags;
